import { z } from "zod";
/**
 * A single feature flag entry.
 * `enabled` = global on/off for all users.
 * `userIds` = explicit per-user overrides (user.id / uid) that are always on
 * regardless of the global switch.
 */
export const FeatureFlagEntrySchema = z.object({
    enabled: z.boolean().default(false),
    userIds: z.array(z.string()).default([]),
});
/**
 * Shape of /systemConfig/featureFlags — one entry per gated feature.
 * Extend here when new features are gated.
 */
export const FeatureFlagsConfigSchema = z.object({
    guestGallery: FeatureFlagEntrySchema.optional(),
});
